import Hcaptcha from '@hcaptcha/react-hcaptcha';
import React, { useEffect, useRef } from 'react';

import { H_CAPTCHA_SITEKEY } from '../../config/constants';

type Props = {
  isJoin?: boolean;
  resetCaptcha?: boolean;
  cfCountry: string;
  storeCaptchaResponse: (token: string) => void;
};

const HCaptcha: React.FC<Props> = ({ storeCaptchaResponse, resetCaptcha, cfCountry }) => {
  const captchaRef = useRef<Hcaptcha>(null);

  useEffect(() => {
    if (resetCaptcha) {
      captchaRef.current?.resetCaptcha();
    }
  }, [resetCaptcha]);

  const chinaProps = {
    apihost: 'https://cn1.hcaptcha.com',
    endpoint: 'https://cn1.hcaptcha.com',
    assethost: 'https://assets-cn1.hcaptcha.com',
    imghost: 'https://imgs-cn1.hcaptcha.com',
    reportapi: 'https://reportapi-cn1.hcaptcha.com',
    onload: '',
    render: '',
  };

  if (cfCountry === undefined) {
    return null;
  }

  const isChina = cfCountry === 'CN';

  return (
    <Hcaptcha
      data-test-id="captcha-input"
      {...(isChina ? chinaProps : {})}
      ref={captchaRef}
      sitekey={H_CAPTCHA_SITEKEY}
      onVerify={token => storeCaptchaResponse(token)}
    />
  );
};

export default HCaptcha;
